import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import classNames from 'classnames';

import config from 'config';
import applicationActions from 'common/support/applicationActions';
import focusManager from 'support/focus/FocusManager';
import { toggleLogOverlay } from 'actions/log';
import Focusable from 'components/focus/Focusable';
import Log from './Log';

import styles from './LoggerOverlay.module.scss';
import { VideoCtvRedux } from 'store-types';

interface LogEntry {
  id: number;
  time: string;
  logType: string;
  message: string;
}

interface LogState {
  logs: LogEntry[];
  showOverlay: boolean;
}

interface RootState {
  log: LogState;
}

const mapStateToProps = (state: RootState) => ({
  logs: state.log.logs,
  displayLogs: state.log.showOverlay,
});

const mapDispatchToProps = {
  toggleOverlay: toggleLogOverlay,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface OwnProps {
  children?: React.ReactNode;
}

type LoggerOverlayProps = PropsFromRedux & OwnProps;

class LoggerOverlay extends React.Component<LoggerOverlayProps> {
  previousFocusId: string | number | null = null;

  componentDidUpdate(prevProps: LoggerOverlayProps) {
    const { displayLogs } = this.props;

    if (displayLogs && !prevProps.displayLogs) {
      this.previousFocusId = focusManager.currentFocusId;
      focusManager.setCurrentFocus('logger-overlay');
    }

    if (!displayLogs && prevProps.displayLogs) {
      focusManager.setCurrentFocus(this.previousFocusId);
      this.previousFocusId = null;
    }
  }

  onAction = (action: string): boolean => {
    const { toggleOverlay } = this.props;

    if (
      config.log &&
      config.log.enabled &&
      (action === applicationActions.num4 ||
        action === applicationActions.extra ||
        action === applicationActions.rightStick)
    ) {
      toggleOverlay();
      return true;
    }

    return false;
  };

  render() {
    const { logs = [], displayLogs, children } = this.props;
    return (
      <Focusable
        // @ts-ignore
        focusId="logger-overlay"
        onAction={this.onAction}
        className="w-100 h-100"
        disableFocusOnHover
        render={() => (
          <React.Fragment>
            {displayLogs && (
              <div
                className={classNames(
                  'text-left',
                  'position-absolute',
                  'w-100',
                  'h-100',
                  'p-3',
                  'overflow-auto',
                  styles.loggerOverlay,
                )}
              >
                {logs.map(log => (
                  <Log
                    key={log.id}
                    time={log.time}
                    level={log.logType}
                    message={log.message}
                  />
                ))}
              </div>
            )}
            {children}
          </React.Fragment>
        )}
      />
    );
  }
}

export default connect(
  (state: VideoCtvRedux) => ({
    logs: state.log.logs,
    displayLogs: state.log.showOverlay,
  }),
  { toggleOverlay: toggleLogOverlay },
)(LoggerOverlay);
